import type { Prompt } from '../types';

export function getPromptBiValue(prompt: Prompt): string {
  const part1 = 'promptSlug' in prompt ? prompt.promptSlug : prompt.promptId;
  const part2 =
    prompt.promptParams && Object.keys(prompt.promptParams).length > 0
      ? new URLSearchParams(prompt.promptParams).toString()
      : '';
  return [part1, part2].filter(Boolean).join(':');
}
